import { CollapseGroup, CollapseInfo } from '@cgs/data-access';
import { CollapseInfoDto } from '../../models';
import { winLineMapper } from './win-line.mapper';
import { winPositionMapper } from './win-position.mapper';
import { defaultSpecGroupMapper } from './default-spec-group.mapper';

export function collapseInfoMapper(collapseInfoData: CollapseInfoDto): CollapseInfo {
  const collapseInfo = new CollapseInfo();
  collapseInfo.groups = (collapseInfoData.groups || [])?.map((item) => {
    const group = new CollapseGroup();
    group.newReels = item.newReels || [];
    group.positions = item.positions || [];
    group.winLines = winLineMapper(item.winLines || []);
    group.winPositions = winPositionMapper(item.winPositions || []);
    group.type = item.type!;
    group.multiplier = item.multiplier!;
    group.roundWin = item.roundWin!;
    group.viewReels = item.viewReels;
    group.specialSymbolGroups = defaultSpecGroupMapper(item.defaultSpecGroups || []);
    return group;
  });

  return collapseInfo;
}
